import { classNames, React } from '@api';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import { FilterNone } from '@material-ui/icons';
import * as css from './DuplicateIcon.css'

export class DuplicateIcon extends React.Component<SvgIconProps> {
  render() {
    const {props} = this
    return <FilterNone {...props} className={classNames(props.className, css.root)} />
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/icons/DuplicateIcon.tsx